import type { FaireProductEntity } from "../../entity_types/product";

export const p_fh8q69quum: FaireProductEntity = {
  token: "p_fh8q69quum",
  type: "product",
  name: "Double Dice Charm for Necklace and Jewelry Making CPG2351",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/0ce58e1ea0c9857562d4bf2ba00beafde47e43423e1f343423179a97a4f28ef5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/072e715730f0d8296b9c82ed1ae7a6c587c22c1ca56aa11d2f51c851e56cb738.jpeg",
    "https://cdn.faire.com/fastly/ee2e29ea00ea65b101540da75437128644f343dd9b6a121ff37bc35103b020a9.jpeg",
    "https://cdn.faire.com/fastly/dcde88bd30c2390afc54c0e2c178b14305e2dceadd75d0560e142c538f1c5c10.jpeg",
    "https://cdn.faire.com/fastly/b81d3495f269b65c1666df1d0f35143ca73ed031f437109d0630f2c85f337d0c.jpeg",
    "https://cdn.faire.com/fastly/8fa64dbe3784cf7b274aa56db0771be024cb8d068a252b5a997f47a318d2398b.jpeg",
  ],
  priceDollars: 7.44,
  description:
    "Gold Double Dice Charm For Jewelry Making,High Polished Shiny Smooth Finished,CPG2351\nListing Is For One Single Piece.\n\n14K Gold Plating Over Brass\nMeasurements:19.5mm x 13.9mm\nThickness:1.8mm\nOpen Jump Ring:3mm\nAll Sizes Are Approximate\nLead, Cadmium and nickel free\nQuantity discount available at drop down menu\nShips From Los Angeles",
  tags: [],
  msrpDollars: 14.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:58.002Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
